<template>
  <section class="container">
    <div class="columns" style="border-bottom: 2px solid #ffffff">
      <div class="column topmenu">
        <i class="fa fa-user fa-2x white" />
        <p v-if="user">
          <strong class="white">{{ user.username }}</strong>
        </p>
      </div>
      <div class="column has-text-centered topmenu">
        <img src="@/assets/logo.png" alt />
      </div>
      <div class="column has-text-right topmenu">
        <i class="fa fa-power-off fa-2x white" @click="logout()"></i>
        <p class="has-text-right">
          <strong class="white" @click="logout()">ອອກ</strong>
        </p>
      </div>
    </div>
    <h1 class="title is-1 has-text-centered">
      <u>ໂຕະ</u>
    </h1>
    <hr />
    <ZoneComponent @selecttable="selecttable" />
  </section>
</template>
<style>
.topmenu {
  cursor: pointer;
}
</style>
<script>
import ZoneComponent from "../components/ZoneComponent";
import { sync } from "vuex-pathify";
export default {
  name: "Tables",
  components: { ZoneComponent },
  computed: {
    user: sync("user"),
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    selecttable(table) {
      this.table = table;
      this.$router.replace("/table/" + this.table.id);
    },
    logout() {
      this.user = null;
      this.$router.replace("/login");
    },
  },
};
</script>